import React, { useState, createElement } from 'react';
import { Popup } from './common/Popup';
import { ChevronUpIcon } from 'lucide-react';
export function Footer() {
  const [activePopup, setActivePopup] = useState<string | null>(null);
  const openPopup = (popupId: string) => {
    // Special handling for privacy policy and terms - download as text files
    if (popupId === 'privacy') {
      downloadPrivacyPolicy();
      return;
    }
    if (popupId === 'terms') {
      downloadTerms();
      return;
    }
    setActivePopup(popupId);
  };
  const closePopup = () => {
    setActivePopup(null);
  };
  const downloadPrivacyPolicy = () => {
    const privacyContent = `# Kraya Privacy Policy
_Last Updated: July 15, 2025_

At Kraya, your privacy is important to us. This policy outlines how we collect, use, and safeguard your data.

## What We Collect
- Card-linked transaction data (for rewards purposes only)
- Basic contact information (email, name)
- Device and location data (to surface nearby offers)

## How We Use Your Data
- To automatically issue rewards when you shop at local stores
- To show you relevant offers and recommendations
- To improve app performance and detect fraud

## What We Don't Do
- We never sell your data.
- We never share personal details without your explicit permission.

## Data Retention
Your data is stored securely and retained only as long as needed for rewards and compliance.

## Contact Us
For any questions, email us at privacy@kraya.app`;
    // Create a Blob from the text content
    const blob = new Blob([privacyContent], {
      type: 'text/plain'
    });
    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);
    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.download = 'kraya_privacy_policy.txt';
    // Append to the document, click, and remove
    document.body.appendChild(link);
    link.click();
    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  const downloadTerms = () => {
    const termsContent = `# Kraya Terms of Use
_Last Updated: July 15, 2025_

Welcome to Kraya. By using our platform, you agree to the following terms.

## Eligibility
You must be 18+ and legally capable of forming a binding contract.

## Use of Service
You agree not to misuse our platform. You will only use it as intended — to discover local stores and earn rewards.

## Reward Program
Rewards may vary by store. We reserve the right to modify or cancel offers at any time.

## Account Responsibility
You're responsible for maintaining the confidentiality of your login credentials.

## Limitation of Liability
Kraya is not liable for issues arising from third-party merchants or payment processors.

## Contact Us
Questions? Reach out at support@kraya.app`;
    // Create a Blob from the text content
    const blob = new Blob([termsContent], {
      type: 'text/plain'
    });
    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);
    // Create a temporary anchor element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.download = 'kraya_terms_of_use.txt';
    // Append to the document, click, and remove
    document.body.appendChild(link);
    link.click();
    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      <footer className="relative bg-[#D4F57A]" data-id="element-206" data-mp="2pbuva8bzuvdg">
        {/* Animated ocean wave — full width */}
        <div className="w-full overflow-hidden h-[70px]" aria-hidden="true" data-id="element-207" data-mp="2kcry1a299tg1">
          <div className="animate-wave-scroll w-[200%] h-full flex" data-id="element-208" data-mp="2fe6zdf2njhtp">
            <svg viewBox="0 0 1440 70" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-1/2 h-full flex-shrink-0" preserveAspectRatio="none" data-id="element-209" data-mp="2fdym3m2maahz">
              <rect width="1440" height="70" fill="#D4F57A" data-id="element-210" data-mp="2rvzmldivw5tp" />
              <path d="M0 70H1440V40C1440 40 1400 10 1320 25C1240 40 1200 5 1120 20C1040 35 1000 0 920 18C840 36 800 5 720 22C640 39 600 2 520 18C440 34 400 0 320 20C240 40 200 5 120 22C40 39 0 10 0 10V70Z" fill="#FFFC00" data-id="element-211" data-mp="2rug5xltbfsre" />
              <path d="M0 70H1440V52C1440 52 1400 30 1320 38C1240 46 1200 25 1120 34C1040 43 1000 22 920 32C840 42 800 24 720 34C640 44 600 22 520 32C440 42 400 22 320 34C240 46 200 25 120 34C40 43 0 28 0 28V70Z" fill="#1A1A1A" data-id="element-212" data-mp="2nv7b0dmjhou9" />
            </svg>
            <svg viewBox="0 0 1440 70" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-1/2 h-full flex-shrink-0" preserveAspectRatio="none" data-id="element-213" data-mp="31khh5d0klgow">
              <rect width="1440" height="70" fill="#D4F57A" data-id="element-214" data-mp="1q52oglfe9azl" />
              <path d="M0 70H1440V40C1440 40 1400 10 1320 25C1240 40 1200 5 1120 20C1040 35 1000 0 920 18C840 36 800 5 720 22C640 39 600 2 520 18C440 34 400 0 320 20C240 40 200 5 120 22C40 39 0 10 0 10V70Z" fill="#FFFC00" data-id="element-215" data-mp="1v6i6s5q6t3ea" />
              <path d="M0 70H1440V52C1440 52 1400 30 1320 38C1240 46 1200 25 1120 34C1040 43 1000 22 920 32C840 42 800 24 720 34C640 44 600 22 520 32C440 42 400 22 320 34C240 46 200 25 120 34C40 43 0 28 0 28V70Z" fill="#1A1A1A" data-id="element-216" data-mp="1wmdvxit8sy1e" />
            </svg>
          </div>
        </div>
        {/* Footer body */}
        <div className="bg-[#1A1A1A]" data-id="element-217" data-mp="zxy41g2nucl4">
          <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 py-6" data-id="element-218" data-mp="1dnrs3w6ccsts">
            {/* Row 1: Kraya name + Back to top */}
            <div className="flex items-center justify-between mb-4" data-id="element-219" data-mp="18wtamt9m9ooy">
              <span className="text-4xl text-white leading-none" style={{
              fontFamily: "'Modak', cursive"
            }} data-id="element-220" data-mp="l7h5c4heu0rx">
                Kraya
              </span>
              <button onClick={scrollToTop} className="inline-flex items-center justify-center gap-1.5 bg-[#FFFC00] text-[#1A1A1A] font-bold px-4 py-2 rounded-full hover:bg-white transition-colors text-sm" data-id="element-221" data-mp="2gbf4be2bdmr2">
                <span data-id="element-222" data-mp="2q2szj9n8g0ee">Back to top</span>
                <ChevronUpIcon className="h-4 w-4 stroke-[3]" data-id="element-223" data-mp="2uzt75ozqdb7m" />
              </button>
            </div>

            {/* Row 2: All links in one line */}
            <div className="flex flex-wrap items-center gap-x-2 gap-y-2 text-sm" data-id="element-224" data-mp="1xdvq7w101dxs">
              <span className="font-black text-white uppercase tracking-wider text-xs" data-id="element-225" data-mp="22b4e8d8twc6y">
                Company
              </span>
              {[{
              id: 'about',
              label: 'About'
            }, {
              id: 'team',
              label: 'Team'
            }, {
              id: 'careers',
              label: 'Careers'
            }, {
              id: 'press',
              label: 'Press'
            }].map(item => <button key={item.id} onClick={() => openPopup(item.id)} className="text-gray-400 hover:text-[#FFFC00] font-bold transition-colors focus:outline-none" data-id="element-226" data-mp="172aj5tcsb24x">
                  {item.label}
                </button>)}
              <span className="text-gray-600 mx-1 hidden sm:inline" data-id="element-227" data-mp="se5vsc2se2ft">|</span>
              <span className="font-black text-white uppercase tracking-wider text-xs" data-id="element-228" data-mp="nd06ko8c4xb1">
                Resources
              </span>
              {[{
              id: 'for-merchants',
              label: 'Merchants'
            }, {
              id: 'help-center',
              label: 'Help'
            }, {
              id: 'privacy',
              label: 'Privacy'
            }, {
              id: 'terms',
              label: 'Terms'
            }].map(item => <button key={item.id} onClick={() => openPopup(item.id)} className="text-gray-400 hover:text-[#FFFC00] font-bold transition-colors focus:outline-none" data-id="element-229" data-mp="1mk20kyvb7qx8">
                  {item.label}
                </button>)}
            </div>

            {/* Bottom 3D Box */}
            <div className="relative mt-8" data-id="element-230" data-mp="12x4bemfe0ons">
              {/* Yellow shadow layer */}
              <div className="absolute inset-0 bg-[#FFFC00] rounded-2xl translate-x-2 translate-y-2" data-id="element-231" data-mp="oxmibuv26p8m" />
              {/* Main box */}
              <div className="relative bg-[#2A2A2A] border-2 border-[#FFFC00] rounded-2xl px-8 py-5 flex flex-col xl:flex-row items-center justify-between gap-4" data-id="element-232" data-mp="twz92qp1wggh">
                <div className="flex flex-col xl:flex-row items-center gap-3 text-center xl:text-left flex-wrap" data-id="element-233" data-mp="2oaqmm1ai3kh7">
                  <span className="text-3xl text-white leading-none" style={{
                  fontFamily: "'Modak', cursive"
                }} data-id="element-234" data-mp="cnwx2lydrczb">
                    Kraya
                  </span>
                  <span className="text-gray-400 font-medium text-base" data-id="element-235" data-mp="hlygj7zpxebb">
                    Go outside. Support local. Earn cool stuff.
                  </span>
                  <span className="text-gray-200 font-bold text-lg xl:ml-2" data-id="element-236" data-mp="vbic9tuvtbb4">
                    © 2026 KRAYA. KRAYA is a product of HAERUMBAH PRIVATE LIMITED. All rights reserved.
                  </span>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0" data-id="element-237" data-mp="1596h5cm7bz70">
                  <span className="bg-[#FFFC00] text-[#1A1A1A] px-4 py-1.5 rounded-full font-black text-xs tracking-widest uppercase" data-id="element-238" data-mp="10d7ovdxr5x1b">
                    Made for Local
                  </span>
                  <span className="text-gray-500 text-sm font-bold hidden sm:inline" data-id="element-239" data-mp="325duam835y72">
                    © {new Date().getFullYear()}
                  </span>
                </div>
              </div>
            </div>
            <p className="text-center text-gray-600 text-xs font-medium mt-4 sm:hidden" data-id="element-240" data-mp="dx8g8j5kim6s">
              © {new Date().getFullYear()} Kraya. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Company Popups */}
      <Popup isOpen={activePopup === 'about'} onClose={closePopup} title="About" data-id="element-241" data-mp="11kzsxnv0t18l">
        <p className="text-gray-700 font-medium text-lg" data-id="element-242" data-mp="wmy8ozluyvvj">
          Kraya is on a mission to make local shopping rewarding again —
          blending online convenience with the magic of discovering and
          supporting neighborhood spots.
        </p>
      </Popup>

      <Popup isOpen={activePopup === 'team'} onClose={closePopup} title="Team" data-id="element-243" data-mp="1kbr8561ovluw">
        <p className="text-gray-700 font-medium text-lg" data-id="element-244" data-mp="1fkhkgazpasln">
          We're a small, scrappy team of product thinkers, engineers, and
          creators passionate about real-world commerce. Want to build with us?
        </p>
      </Popup>

      <Popup isOpen={activePopup === 'careers'} onClose={closePopup} title="Careers" data-id="element-245" data-mp="1rvs3didzq3x1">
        <p className="text-gray-700 font-medium text-lg" data-id="element-246" data-mp="1ws8qc99gec8j">
          Help shape the future of hybrid shopping. Check back soon — we're not
          hiring yet, but we will be soon.
        </p>
      </Popup>

      <Popup isOpen={activePopup === 'press'} onClose={closePopup} title="Press" data-id="element-247" data-mp="26rhq5ir02l2t">
        <p className="text-gray-700 font-medium text-lg" data-id="element-248" data-mp="2ari4l3e3mw9v">
          For media inquiries, product assets, and partnership stories, reach
          out to{' '}
          <a href="mailto:press@kraya.app" className="text-[#1A1A1A] font-bold hover:underline" data-id="element-249" data-mp="2kicuqiugug0l">
            press@kraya.app
          </a>
        </p>
      </Popup>

      {/* Resources Popups */}
      <Popup isOpen={activePopup === 'for-merchants'} onClose={closePopup} title="For Merchants" data-id="element-250" data-mp="2uhtw4o2oq7qr">
        <div className="space-y-6" data-id="element-251" data-mp="1zudcbh1d9eca">
          <p className="text-gray-700 font-medium text-lg" data-id="element-252" data-mp="1zvek9cn35kps">
            List your store on Kraya and turn everyday visits into lasting
            loyalty. No hardware. No headaches. Just better repeat business.
          </p>
          <div data-id="element-253" data-mp="29r86xouiqula">
            <a href="#merchants" onClick={closePopup} className="inline-flex items-center bg-[#FFFC00] text-[#1A1A1A] font-bold px-6 py-3 rounded-full hover:bg-[#e6e300] transition-colors" data-id="element-254" data-mp="29qge2lsb3ayp">
              Learn More
            </a>
          </div>
        </div>
      </Popup>

      <Popup isOpen={activePopup === 'help-center'} onClose={closePopup} title="Help Center" data-id="element-255" data-mp="2sjaiwmw7tmp7">
        <p className="text-gray-700 font-medium text-lg" data-id="element-256" data-mp="135471uhbl54w">
          Need support? Visit our Help Center to explore FAQs, tutorials, and
          account assistance. (Coming soon.)
        </p>
      </Popup>
    </>;
}